import { AccountGroupType } from '../../../types/account-groups/account-group.dto';
import type { Column } from '../dev-express/types/table.types';

/**
 * The AccountGroupFilter dropdown: filters a tab's rows to exactly one account-group type
 * (Pool or Program), matching the ES/DB `accountGroupType` field directly (POOL/PROGRAM).
 * Reused across every tab that adds this filter (Accounts, Policies, Quote, Claims, and later
 * Submission) so the option list, filter semantics, and column shape stay in one place rather
 * than being hand-copied per tab the way the older poolName/programName columns were.
 */
export const ACCOUNT_GROUP_TYPE_FILTER_OPTIONS: ReadonlyArray<{
  readonly label: string;
  readonly value: string;
}> = [
  { label: 'Pool', value: AccountGroupType.POOL },
  { label: 'Program', value: AccountGroupType.PROGRAM },
];

export const ACCOUNT_GROUP_TYPE_FILTER_TITLE = 'Account Group Type';

export function getAccountGroupTypeFilterColumn<
  TRow = unknown,
  TCtx = unknown
>(): Partial<Column<TRow, TCtx>> {
  return {
    name: 'accountGroupType',
    title: ACCOUNT_GROUP_TYPE_FILTER_TITLE,
    show: false,
    canToggle: false,
    filterType: 'singleSelect',
    getListOptions: async () => [...ACCOUNT_GROUP_TYPE_FILTER_OPTIONS],
    getCellValue: () => null,
  };
}
